import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';

const VivaEngagePanelButton = () =>
  import(/* webpackChunkName: "4-feat-vivaengagepanelbutton" */ './VivaEngagePanelButton');
export default lazyLoadOnRender({ loader: VivaEngagePanelButton });
